<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}"
            *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">

                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}"
                            *ngIf="showNavComponent"></app-plugin-navbar>
                    </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title">
                                        <h2 class="screen-reader">{{ 'AnnualReport' | translate }}</h2>
                                    </div>
                                    <div class="description">
                                        <div class="annual-report">
                                            <div class="row">
                                                <div class="col-lg-12">

                                                    <!-- Annual Report area -->

                                                    <div class="calender-main text-center">
                                                        <div class="row">

                                                            <div *ngFor="let item of annualList| paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};"
                                                                class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-4">
                                                                <div class="card">
                                                                    <div class="card-body">

                                                                        <div class="icon"> <i
                                                                                class="bi bi-file-earmark-pdf"></i>
                                                                        </div>

                                                                        <div class="calendar-txt screen-reader font-adjust"> {{
                                                                            language=='English'?item.reportName:item.reportNameInHindi
                                                                            }} {{ jsonConvert(item,'FROM_YEAR')
                                                                            }}-{{jsonConvert(item,'TO_YEAR') }} </div>
                                                                        <hr>

                                                                        <div
                                                                            class="d-flex align-items-center justify-content-between">
                                                                            <div *ngIf="checkFileExists(item)">
                                                                                <div class="opening-date font-adjust">
                                                                                    <strong class="d-block">
                                                                                        <a [href]="backend_url+'storage/app/uploads/'+item.selectDocument"
                                                                                            [download]="item.selectDocument"
                                                                                            target="_blank"
                                                                                            [attr.title]="language=='English'?'Download File':'डाउनलोड फ़ाइल'"
                                                                                            class="text-green screen-reader"><span
                                                                                                class="me-2"> <i
                                                                                                    class="bi bi-download me-1"></i>{{
                                                                                                'Download' | translate
                                                                                                }}</span></a>
                                                                                    </strong>
                                                                                    <span class="labels text-muted screen-reader">({{
                                                                                        item.selectDocument_details.fileSize
                                                                                        }} <span style="text-transform: uppercase;" *ngIf="checkFileType(item)!==false" [innerHtml]="checkFileType(item).file"></span>) </span>
                                                                                </div>
                                                                        </div>

                                                                            <div *ngIf="checkFileExists(item)">
                                                                                <a href="javasript:void(0);"
                                                                                    (click)="ViewDocument(backend_url+'storage/app/uploads/',item.selectDocument)"
                                                                                    class="text-green"
                                                                                    [attr.title]="language=='English'?'View Details':'विवरण देखें'"> <i
                                                                                        class="bi bi-eye me-1"></i>{{ 'View'
                                                                                    | translate }}</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>
                                                        <pagination-controls id="pg1" class="text-center screen-reader"
                                                            (pageChange)="pageChanged($event)"
                                                            *ngIf="totalRecords > 10"></pagination-controls>
                                                    </div>

                                                    <!-- Annual Report area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>